module.exports = __webpack_public_path__ + "static/media/1-1.fb21eace.mp3";